import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { IDocument, ITagline } from "../../infrastructure/interfaces";
import Radio from "../Radio";
import { changeDocumentTitle } from "../../actions/actions";
import {taglinesForDocument} from '../../infrastructure/Taglines';

/* change the document.title on selection in redux */
interface IReduxStateProps {
  taglines: ITagline[];
  document: IDocument;
}
interface IDispatchProps {
  changeTitle(title: string): void;
}
const mapStateToProps = (state: any): IReduxStateProps => {
  return {
    taglines: state.wizard.taglines,
    document: state.document,
  };
};
const mapDispatchToProps = (dispatch: any): IDispatchProps => {
  return {
    changeTitle: (title: string) => {
      dispatch(changeDocumentTitle(title));
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
class TitleChoosing extends React.Component<PropsFromRedux> {
  render() {
    const taglines = taglinesForDocument(this.props.taglines, this.props.document);

    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">Select cover title:</div>
        </div>
        <div>
          <div className="stepContent">
            {taglines
              .map((tagline, ix) => (
              <div key={ix} className="rowStepTwo">
                <Radio
                  checked={this.props.document.title === tagline.title}
                  onChange={() => this.props.changeTitle(tagline.title)}
                >
                  <div className="image-box">
                    <span>{tagline.title.replace(/<br\/>/g, " ")}</span>
                  </div>
                </Radio>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default connector(TitleChoosing);



// WEBPACK FOOTER //
// ./src/components/Steps/TitleChoosing.tsx